import { useEffect } from "react";

export const useRefresh = (workType, navigate) =>
  useEffect(() => {
    if (workType === "") {
      navigate(`/`);
    }
  });
